var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 896 896",
    style: {
      enableBackground: "new 0 0 896 896"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_490",
    className: "st0",
    d: "M685.5,0H211.3C95,0,0.4,94.2,0.4,210.9l0,0v474.3C0.4,801.4,94.6,896,210.9,896l0,0h261.3 V549.3H355.5V413.8h116.7v-99.6C463,224.6,528.4,145,618,135.9l0,0c9.2-0.8,18.8-1.3,27.9-0.4c34.6,0,69.6,1.7,104.2,5.4v120.9 h-71.7c-56.3,0-67.1,26.7-67.1,65.8v86.3h133.8l-17.5,135H611.4v346.7h73.3c116.3,0,210.9-94.2,210.9-210.9l0,0V210.5 C896,94.2,801.8,0,685.5,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9d6681d988bb05427229b14b3d30b60e.svg";
export { ForwardRef as ReactComponent };